// removed by extract-text-webpack-plugin
module.exports = {"ellipsis":"_22bQPb2wJUJvPetU2jW1M5","sourceText":"a4B9ev4UhAKVgO3aoEODz","sourceIcon":"_1uTJKBsx1QimFiTiIZSBpI"};